module.exports = __webpack_public_path__ + "static/media/design-detail.0259aa94.svg";